import React, { createContext, useContext, useEffect, useState } from 'react'
import { IProps, IBrand, BrandOptions } from './index'
import globalDefaultCSS from 'marketing-site/src/styles/themes/default-global.scss'
import globalLegacyCSS from 'marketing-site/src/styles/themes/legacy-global.scss'

export const brandKey = 'intercom-theme'
export const defaultBrand = 'legacy' as IBrand

const getBrandFromEnv = () => {
  const brand = process?.env?.NEXT_PUBLIC_INTERCOM_BRAND as IBrand
  if (brand && isAnAvailableBrand(brand)) {
    return brand
  }
  return defaultBrand
}

const isAnAvailableBrand = (brand: string) =>
  !!Array.from(Object.keys(BrandOptions)).includes(brand)

export const BrandContext = createContext(defaultBrand)

export const BrandProvider = ({ children, forcedBrand }: IProps) => {
  const [theme, setTheme] = useState<IBrand>(forcedBrand || getBrandFromEnv())

  useEffect(() => {
    if (forcedBrand) {
      setTheme(forcedBrand)
      return
    }

    window.switchIntercomBrand = (brand: IBrand) => {
      if (isAnAvailableBrand(brand)) {
        setTheme(brand)
      }
    }

    return function () {
      window.switchIntercomBrand = () => {}
    }
  }, [forcedBrand, setTheme])

  return (
    <BrandContext.Provider value={theme}>
      {theme === BrandOptions.default && <style jsx>{globalDefaultCSS}</style>}
      {theme === BrandOptions.legacy && <style jsx>{globalLegacyCSS}</style>}
      {children}
    </BrandContext.Provider>
  )
}

export const useBrand = () => useContext(BrandContext)
